import axios from 'axios';

// API基础URL - 使用相对路径
const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:5000/api';

console.log('环境:', process.env.NODE_ENV);
console.log('API_URL:', API_URL); // 添加更多调试信息

// 创建axios实例
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000, // 15秒超时时间，防止请求无限等待
});

// 请求拦截器 - 添加认证令牌
api.interceptors.request.use(
  (config) => {
    console.log('API请求:', config.url); // 添加调试信息
    
    // 从本地存储获取认证令牌
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器 - 统一处理错误
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // 处理网络错误
    if (!error.response) {
      console.error('网络错误，请检查您的互联网连接');
      return Promise.reject({
        message: '网络错误，请检查您的互联网连接或服务器可能已关闭',
      });
    }

    // 处理超时
    if (error.code === 'ECONNABORTED') {
      console.error('请求超时，请稍后重试');
      return Promise.reject({
        message: '请求超时，请稍后重试',
      });
    }

    // 处理401未授权 - 可能是token过期
    if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // 如果不在登录页面，则重定向到登录页
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }

    // 处理其他HTTP错误
    console.error('API错误:', error.response?.data?.message || error.message);
    return Promise.reject(error.response?.data || error);
  }
);

export default api; 